import React, { useEffect, useLayoutEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { setGlobalLoader } from "../../../redux/slices/globalLoader";
import GlobalLoader from "./globalLoader";
import { setUserType } from "../../../redux/slices/userType";
import Header from "./header";
import { useDispatch, useSelector } from "react-redux";
import { getRestaurantSettings } from "../services/table.services";
import { addRestData } from "../../../redux/slices/restSettings";
import { SOCKET_CLIENT } from "../../../utils/socket";
import { ROLE, SOCKET_CLIENT_EVENTS, SOCKET_EVENTS, SWAL_SETTINGS } from "../../../utils/Constants";
import { getDate, getLocalKey, hideMainLoader, logOutUser, TrimText } from "../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";

const CashierLayout = () => {
  let printerConnection2 = null;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loaderState = useSelector((state) => state.globalLoader);
  const [restaurantDetailChanged, setRestaurantDetailChanged] = useState(false);
  const { t, i18n } = useTranslation();
  // console.log(i18n.language)
  useEffect(() => {
    const body = document.querySelector("body");
    if (body) {
      body.classList.add("restaurant_inner_body");
    }
  }, []);

  useLayoutEffect(() => {
    dispatch(setUserType("admin"));
    Promise.all([import("../../../assets/cashier/css/style.css"), import("../../../assets/restaurant/css/style.css")]).then(() => {
      dispatch(setGlobalLoader(false));
      hideMainLoader();
    });
  }, []);

  /** Joining user to socket for realtime notifications <<<<< */
  useEffect(() => {
    const handleSocketData = async (response) => {
      if (response) {
        if (response?.event === SOCKET_EVENTS.STAFF_DELETED) {
          try {
            const currentCashier = JSON.parse(getLocalKey("cashierDetail"));
            if (response?.data?.deleted_staff_id === currentCashier._id) {
                logOutUser(ROLE.CASHIER, navigate);
                Swal.fire({
                    icon: "error",
                    text: response.message,
                    ...SWAL_SETTINGS,
                  });
            }
          } catch (error) {
            console.log("Error====>", error);
          }
        }
      }
    };

    SOCKET_CLIENT.on(SOCKET_CLIENT_EVENTS.GET_DATA, handleSocketData);

    return () => {
      SOCKET_CLIENT.off(SOCKET_CLIENT_EVENTS.GET_DATA, handleSocketData);
    };
  }, [navigate]);

  /** Joining user to socket for realtime notifications <<<<< */
  // useMemo(() => {
  //     SOCKET_CLIENT.on('GET-DATA', async (response) => {
  //         if (response) {
  //             if (response?.event === SOCKET_EVENTS.RESTAURANT_DETAILS_CHANGED) {
  //                 console.log("socket event listened")
  //                 setRestaurantDetailChanged(!restaurantDetailChanged)
  //             }
  //             else if(response?.event === SOCKET_EVENTS.ORDER_PLACED){
  //                 const printer = await getPrinter(PRINTER_NAMES.KITCHEN_PRINTER);
  //                 if(printer){
  //                     // console.log(response , "data for kitchen printer")
  //                     addKitchenPrint(printer , response , t , i18n.language);
  //                     if (response.data.ordered_items.some(item => item.item_variation === "food")) {
  //                     addKitchenFoodPrint(printer , response , t , i18n.language);
  //                 }
  //                     if (response.data.ordered_items.some(item => item.item_variation === "drink")) {
  //                         addKitchenDrinkPrint(printer,response , t , i18n.language);
  //                     }

  //                 }
  //             }
  //         }
  //     });
  // }, [restaurantDetailChanged]);

  // useMemo(() => {
  //     getRestaurantSettings().then((globalDetails) => {
  //         dispatch(addRestData(globalDetails?.data));
  //     });
  // }, [restaurantDetailChanged]);
  useEffect(() => {
    getRestaurantSettings().then((globalDetails) => {
      dispatch(addRestData(globalDetails?.data));
      setRestaurantDetailChanged(false);
    });
  }, [restaurantDetailChanged, dispatch]);

  return (
    <>
      {loaderState ? (
        <GlobalLoader />
      ) : (
        <div>
          <Header />
          <Outlet />
        </div>
      )}
    </>
  );
};
export default CashierLayout;
